"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.substituteAndCalculateRoiResult = exports.substituteRoiValuesInFormula = void 0;
var lodash_1 = require("lodash");
var MathExpressionEvaluatorAdapter_1 = __importDefault(require("./MathExpressionEvaluatorAdapter"));
var ROIVariableNotFoundError_1 = __importDefault(require("./ROIVariableNotFoundError"));
var VARIABLE_REPLACEMENT_REGEX = /{{(\w+?)}}/g;
var substituteRoiValuesInFormula = function (formula, variables, sliderValue) {
    return formula.replace(VARIABLE_REPLACEMENT_REGEX, function (_) {
        var captureGroups = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            captureGroups[_i - 1] = arguments[_i];
        }
        var _a = __read(captureGroups, 1), variableName = _a[0];
        if (variableName === "slider") {
            return sliderValue.toString();
        }
        var variable = variables[variableName];
        if (!variable) {
            throw new ROIVariableNotFoundError_1.default(variableName);
        }
        return variable.value.toString();
    });
};
exports.substituteRoiValuesInFormula = substituteRoiValuesInFormula;
exports.substituteAndCalculateRoiResult = (0, lodash_1.flow)(exports.substituteRoiValuesInFormula, MathExpressionEvaluatorAdapter_1.default);
